let serviceid='service_xcrx46l';
let templateid='template_9gidlyt';
let password='A0EqNo5pIzHiECBz7';

export {serviceid,templateid,password};